import React, { useEffect, useMemo, useState } from "react";

import { LoaderPage } from "pages/Loader-page/LoaderPage";
import { useAccountSelector, useDealActions, useInvestorsSelector, useReportsFiltersSelector } from "store";

export const MonitoringInvestor: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { show_global_investor_filter } = useAccountSelector() || {};
  const [isChecked, setIsChecked] = useState(!show_global_investor_filter);

  const { setMeasureDataTableFiltersAction: setDataFilters } = useDealActions();

  const filters = useReportsFiltersSelector();
  const investorsFilter = (filters?.Investor as string[]) || [];
  const investors = useInvestorsSelector();
  const pickedInvestors = useMemo(
    () =>
      investors
        .filter((investor) => investorsFilter.includes(investor.name))
        .map((investor) => ({ id: investor.id, name: investor.name })),
    [investors, investorsFilter]
  );

  useEffect(() => {
    // Skip checking if no investors are selected or global filter is disabled
    if (!show_global_investor_filter) return;
    if (!investorsFilter.length) {
      return setIsChecked(true);
    }

    // Set selected investors to measure_data filters and unlock the page
    setDataFilters({
      investors: pickedInvestors
    });
    // setTimeout is used to wait while store dispatch completes itself before unlock the page
    setTimeout(() => {
      setIsChecked(true);
    }, 0);
  }, []);

  if (!isChecked) return <LoaderPage loading={true} />;

  return <React.Fragment>{children}</React.Fragment>;
};
